module.exports = __webpack_public_path__ + "img/underline.f0a965cf.svg";